import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { WhiteLabel } from './white-label';

export const WHITE_LABEL_RULES = new InjectionToken<WhiteLabelRule<any>[]>('WHITE_LABEL_RULES');

export interface WhiteLabelRule<WhiteLabelConfigType = WhiteLabel> {
    whiteLabelRule$: Observable<Partial<WhiteLabelConfigType>>;
}

export interface WhiteLabelRuleSnapshot<WhiteLabelConfigType = WhiteLabel> {
    whiteLabelRule: Partial<WhiteLabelConfigType>;
}
